export enum ReportKind {
  combineTestReport = 'combineTestReport',
  compareReport = 'compareReport',
  multiGroupReport = 'multiGroupReport',
  puttingCompareReport = 'puttingCompareReport',
  puttingMultiGroupReport = 'puttingMultiGroupReport',
  puttingSingleGroupReport = 'puttingSingleGroupReport',
  puttingSingleShotReport = 'puttingSingleShotReport',
  singleGroupReport = 'singleGroupReport',
  singleShotReport = 'singleShotReport',
  testCenterReport = 'testCenterReport',
  drShotAnalysis = 'drShotAnalysis',
  notDefined = '',
}

export function GetReportKind(kind: string): ReportKind {
  switch (kind) {
    case 'combineTestReport':
      return ReportKind.combineTestReport;
    case 'compareReport':
      return ReportKind.compareReport;
    case 'multiGroupReport':
      return ReportKind.multiGroupReport;
    case 'puttingCompareReport':
      return ReportKind.puttingCompareReport;
    case 'puttingMultiGroupReport':
      return ReportKind.puttingMultiGroupReport;
    case 'puttingSingleGroupReport':
      return ReportKind.puttingSingleGroupReport;
    case 'puttingSingleShotReport':
      return ReportKind.puttingSingleShotReport;
    case 'singleGroupReport':
      return ReportKind.singleGroupReport;
    case 'singleShotReport':
      return ReportKind.singleShotReport;
    case 'testCenterReport':
      return ReportKind.testCenterReport;
    case 'drShotAnalysis':
      return ReportKind.drShotAnalysis;
    default:
      return ReportKind.notDefined;
  }
}
